/* eslint-disable prefer-template */
import { useState } from 'react';
import {
    Table, Input, Select, SelectOption,
} from 'appkit-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const ConfigurationTable = ({
    selectedColumns, onFilterSave,
    onOperationSave,
}) => {
    /* List of columns for Configuration Table */
    const columns = [{
        Header: 'Columns',
        accessor: 'column',
        minWidth: 70,
        resizable: true,
    }, {
        Header: 'Data Type',
        accessor: 'dataType',
        minWidth: 40,
        resizable: true,
    }, {
        Header: 'Filter',
        minWidth: 60,
        accessor: 'filters',
        Cell: row => {
            const { original: { filters, column } } = row;
            const selectedFilter = filters && filters.filter(val => val.isSelected).map(c => c.functionName)[0];
            /* callback function called when a filter function is selected */
            const onFilterSelect = e => {
                onFilterSave(e, column);
            };
            return (
                <Select
                    placeholder="Select"
                    dropdownRenderMode="portal"
                    value={selectedFilter}
                    onSelect={onFilterSelect}
                    size="default"
                >
                    <SelectOption value="">Select</SelectOption>
                    { filters.map(val => (
                        <SelectOption key={val.functionId} value={val.functionName}>
                            {val.displayName}
                        </SelectOption>
                    ))}
                </Select>
            );
        },
        resizable: true,
    }, {
        Header: 'Operation',
        minWidth: 100,
        style: { overflow: 'unset' },
        Cell: row => {
            const {
                original: {
                    // eslint-disable-next-line camelcase
                    start_date, end_date, dataType, transformation,
                },
            } = row;
            // eslint-disable-next-line camelcase
            const defaultStartDate = start_date === '' ? null : new Date(start_date);
            const [startDate, setStartDate] = useState(defaultStartDate);
            // eslint-disable-next-line camelcase
            const defaultEndDate = end_date === '' ? null : new Date(end_date);
            const [endDate, setEndDate] = useState(defaultEndDate);
            /* callback function called when a operation value is entered */
            const onOperationSelect = e => {
                const { original: { column } } = row;
                onOperationSave(e, column);
            };
            /* callback function called when a start date and end date is selected */
            const onDateChange = dates => {
                const [start, end] = dates;
                setStartDate(start);
                setEndDate(end);
                if (start && end && end > start) {
                    const fromIndex = -2;
                    const monthOffset = 1;
                    const startMonth = `0${start.getMonth() + monthOffset}`.slice(fromIndex);
                    const startDt = `0${start.getDate()}`.slice(fromIndex);
                    const startFormatDate = `${start.getFullYear()}-${startMonth}-${startDt}`;
                    const endMonth = `0${end.getMonth() + monthOffset}`.slice(fromIndex);
                    const endDt = `0${end.getDate()}`.slice(fromIndex);
                    const endFormatDate = `${end.getFullYear()}-${endMonth}-${endDt}`;
                    const dateRange = [startFormatDate, endFormatDate];
                    const { original: { column } } = row;
                    onOperationSave(dateRange, column);
                }
            };
            return (
                <>
                    { dataType === 'date' && (
                        <DatePicker
                            selected={defaultStartDate}
                            dateFormat="yyyy-MM-dd"
                            onChange={onDateChange}
                            placeholderText="Start Date - End Date"
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange
                            className="date-picker-style"
                        />
                    )}
                    { dataType !== 'date' && (
                        <Input
                            placeholder="Value"
                            inputBoxSize="sm"
                            value={transformation}
                            onChange={e => onOperationSelect(e)}
                        />
                    )}
                </>
            );
        },
        resizable: true,
    }, {
        Header: 'Action',
        accessor: '',
        Cell: () => (<span className="appkiticon icon-delete-fill" />),
        minWidth: 30,
        resizable: true,
    }];
    return (
        <Table
            data={selectedColumns.selectedColumns}
            columns={columns}
            defaultPageSize={10}
            showPagination={false}
            sortable={false}
        />
    );
};

export default ConfigurationTable;
